import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractService } from '../../../../services/AbstractService';
import { LlmSettingsDTO } from '../models/llm-settings.dto';
import { LlmModelDTO } from '../models/llm-model.dto';
import { LlmToneDTO } from '../models/llm-tone.dto';
import { LlmTemperatureDTO } from '../models/llm-temperature.dto';
import { environment } from 'src/environments/environment';
import { filter, map } from 'rxjs/operators';
import {OrganisationDTO} from "../../../../DTO/Organisation/OrganisationDTO";
import {OrganisationAccountDTO} from "../../../../../core/dto/OrganisationAccountDTO";

@Injectable({
  providedIn: 'root'
})
export class LlmSettingsService extends AbstractService<LlmSettingsDTO> {

  constructor(protected override http: HttpClient) {
    super(http);
  }

  override getApiURL() {
    return 'llm-settings';
  }

  /**
   * Kurum için LLM ayarlarını getirir
   */
  getOrganizationLlmSettings(organization: OrganisationDTO | OrganisationAccountDTO): Observable<LlmSettingsDTO> {
    return this.http.get<LlmSettingsDTO>(`${environment.apiUrl}${this.getApiURL()}/organizations/${organization.id}`);
  }

  /**
   * Kurum LLM ayarlarını günceller
   */
  updateOrganizationLlmSettings(settings: LlmSettingsDTO): Observable<LlmSettingsDTO> {
    return this.http.post<LlmSettingsDTO>(
      `${environment.apiUrl}${this.getApiURL()}/organizations/${settings.organization.id}`,
      settings
    );
  }

  /**
   * Sistemdeki tüm LLM modellerini getirir
   */
  getAllLlmModels(): Observable<LlmModelDTO[]> {
    return this.http.get<LlmModelDTO[]>(`${environment.apiUrl}${this.getApiURL()}/models`);
  }

  /**
   * Sistemdeki ton seçeneklerini getirir
   */
  getAllTones(): Observable<LlmToneDTO[]> {
    return this.http.get<LlmToneDTO[]>(`${environment.apiUrl}${this.getApiURL()}/tones`);
  }

  /**
   * Sistemdeki temperature (yaratıcılık) modlarını getirir
   */
  getAllTemperatures(): Observable<LlmTemperatureDTO[]> {
    return this.http.get<LlmTemperatureDTO[]>(`${environment.apiUrl}${this.getApiURL()}/temperatures`);
  }

  /**
   * Sadece değişen alanları güncellemek için PATCH metodu - JSON Patch formatında
   */
  patchOrganizationLlmSettings(id: any, patchOperations: any[]): Observable<any> {
    // JSON Patch formatında veriyi gönder
    return this.http.patch<any>(
      `${environment.apiUrl}${this.getApiURL()}/${id}`,
      patchOperations,
      {
        headers: {"Content-Type": "application/json-patch+json"}
      }
    );
  }

  /**
   * Yeni bir ayar kaydı oluşturmak için POST metodu
   */
  createOrganizationLlmSettings(settings: LlmSettingsDTO): Observable<any> {
   return  super.create(settings);
  }
}
